export default __webpack_public_path__ + "static/media/l4.dcf0e045.jpg";